
import Vue from "vue"
import * as d3 from "d3"
import api from "../../../../../api"
import attrs from "../../../../../api/attrs"

class Plot
{
	constructor(objects, sort_by, is_desc)
	{
		this.objects = objects
		this.data = null
		this.sort_by = sort_by
		this.is_desc = is_desc
	}

	update_teach_test()
	{
		let teach_test_ind = 0
		let _data
		let ind = 0

		_data = api.sort_objects_array_by_key(this.data, this.sort_by, this.is_desc)

		_data.forEach(
			elem =>
			{
				elem.ind = ind

				ind ++

				if(! this.objects.bad(elem.id))
				{
					elem.is_teach = (teach_test_ind % 2) ? false : true
					elem.is_test = (teach_test_ind % 2) ? true : false
					teach_test_ind ++
				}
			})

		return _data
	}

	static attr_value(obj, attr, attrs_references)
	{
		var value = obj[attr.key]

		if(attr.type != "number")
			value = attrs_references[attr.id].values[value].default

		return value
	}

	static two_attrs(objects, x_attr, y_attr, attrs_references, sort_by, is_desc)
	{
		var plot = new Plot(objects, sort_by, is_desc)

		plot.data = []

		objects.objects.forEach(
			obj =>
			{
				var desc = {}

				desc.id = obj.id
				desc.uprs = obj.current_version.attrs.uprs
				desc.x = Plot.attr_value(obj, x_attr, attrs_references)
				desc.y = Plot.attr_value(obj, y_attr, attrs_references)

				plot.data.push(desc)
			})

		plot.data = plot.update_teach_test()

		return plot
	}

	static diff(objects, model, attr_key, sort_by = "y", coef = 0)
	{
		var plot = new Plot(objects, sort_by, false)

		plot.data = []

		objects.objects.forEach(
			obj =>
			{
				var desc = {}

				desc.id = obj.id
				desc.uprs = obj.current_version.attrs.uprs
				desc.diff = obj.diff == null ? null : obj.diff[model]
				desc.predicted_uprs = obj.predicted_uprs == null ? null : obj.predicted_uprs[model]

				desc.y = desc[attr_key] + desc[attr_key] * coef

				plot.data.push(desc)
			})

		plot.data = plot.update_teach_test()

		return plot
	}
}

class Objects
{
	constructor(self, group_id, ce_attrs, ce_attrs_references, new_operation_callback, message_callback)
	{
		this.self = self
		this.bus = new Vue()
		this.group_id = group_id
		this.ce_attrs = ce_attrs
		this.ce_attrs_references = ce_attrs_references
		this.new_operation_callback = new_operation_callback
		this.message_callback = message_callback
		this.plots = []

		this.bus.$on("attrs_changed",
			ev =>
			{
				this.set_ce_attrs(ev.ids)

				if(ev.attrs_references != null)
					this.ce_attrs_references = ev.attrs_references
			})
	}

	refresh_objects()
	{
		return this.raw_objects(this.group_id).then(
			objects =>
			{
				let good_count = 0
				let bad_count = 0

				this.objects = objects
				this.objects.forEach(
					obj =>
					{
						obj.selected = false
						obj.bad = obj.current_version.attrs.bad

						if(obj.bad)
							bad_count ++
						else
							good_count ++
					})

				this.good_count = good_count
				this.bad_count = bad_count
				this.count = objects.length
				this.exist = this.count > 0
			})
			.then(() => this.refresh_ce_attrs())
	}

	update_objects(new_objects_state)
	{
		if(this.objects == null)
			return

		this.objects.forEach(
			obj =>
			{
				const new_state = new_objects_state[obj.id]

				if(obj.predicted_uprs == null)
					obj.predicted_uprs = {}

				if(obj.diff == null)
					obj.diff = {}

				if(new_state != null)
					Object.entries(new_state).forEach(
						desc =>
						{
							const model = desc[0]
							const data = desc[1]

							obj.predicted_uprs[model] = data.predicted_uprs
							obj.diff[model] = data.diff
						})
			})

		this.bus.$emit("update_objects")
	}

	set_ce_attrs(ce_attrs_ids)
	{
		let ce_attrs = []

		attrs.get().then(
			desc =>
			{
				desc.attrs.forEach(
					attr =>
					{
						if(ce_attrs_ids.findIndex(id => id == attr.id) >= 0)
							ce_attrs.push(attr)
					})

				this.ce_attrs = ce_attrs

				return this.refresh_ce_attrs()
			}
		)
	}

	refresh_ce_attrs()
	{
		return attrs.get().then(
			desc =>
			{
				this.uprs_attr = desc.attr_uprs

				let _attrs = [ this.uprs_attr, ...this.ce_attrs ]

				this.objects.forEach(obj => _attrs.forEach(attr => { obj[attr.key] = api.get_obj_value(obj.current_version, attr.key) }))
			})
	}
	
	async raw_objects()
	{
		const query = { "current_version.group" : this.group_id, "current_version.attrs.analogue_profitable_type" : "Купля-продажа" }
		let objects = api.call_without_component(this.self, "cadastral_analogues", "get_many", { query : query, is_raw : true }).then(response => response.data)

		return objects
	}

	check_m_criteria(n, bad_count = null)
	{
		const object_count = this.objects.length
		const m = 6 * ( n + 1 )

		if(bad_count == null)
			bad_count = this.bad_count

		if(m > object_count - bad_count)
		{
			this.message_callback("Не хватает объектов-аналогов для построения модели по причине невыполнения критерия 6 ( m + 1 )")

			return false
		}

		return true
	}

	async set_state(ids, is_bad, new_operation = true)
	{
		if(! api.check_roles(this.self, [ "model" ]))
			return

		let good_count = 0
		let bad_count = 0
		let operation = { type : "set_objs_state", obj_ids : [], old_bad : ! is_bad, new_bad : is_bad }

		if(is_bad)
		{
			this.objects.forEach(
				obj =>
				{
					if(obj.bad || ids.find(id => id == obj.id))
						bad_count += 1
				})

			if(! this.check_m_criteria(this.ce_attrs.length, bad_count))
				return

			bad_count = 0
		}

		this.objects.forEach(
			obj =>
			{
				if(ids.find(obj_id => obj.id == obj_id))
				{
					if(obj.bad != is_bad)
					{
						obj.bad = is_bad
						operation.obj_ids.push(obj.id)
					}

					obj.selected = false
				}

				if(obj.bad)
					bad_count ++
				else
					good_count ++
			})

		await api.call_without_component(this.self, "cadastral_groups", "set_analogues_objs_state", { id : this.group_id, ids : ids, bad_key_without_prefix : "bad", state : is_bad })

		this.good_count = good_count
		this.bad_count = bad_count

		this.update_teach_test()

		this.bus.$emit("update_plots")
		this.bus.$emit("evaluate_model")

		if(new_operation)
			this.new_operation_callback(operation)
	}

	async set_state_for_selected(is_bad)
	{
		if(! api.check_roles(this.self, [ "model" ]))
			return

		let ids = []

		this.objects.forEach(
			obj =>
			{
				if(obj.selected)
					ids.push(obj.id)
			})

		this.set_state(ids, is_bad)
	}

	async reset_state(new_operation = true, update_analogues = true)
	{
		if(! api.check_roles(this.self, [ "model" ]))
			return

		if(update_analogues)
			await api.call_without_component(this.self, "cadastral_groups", "set_analogues_objs_state", { id : this.group_id, bad_key_without_prefix : "bad", state : false })
		
		let operation = { type : "set_objs_state", obj_ids : [], old_bad : true, new_bad : false }

		this.objects.forEach(
			obj =>
			{
				if(obj.bad)
				{
					obj.bad = false
					operation.obj_ids.push(obj.id)
				}
			})

		this.good_count = this.objects.length
		this.bad_count = 0

		this.update_teach_test()

		this.bus.$emit("update_plots")
		this.bus.$emit("evaluate_model")
		this.bus.$emit("refresh_statistic")

		if(new_operation)
			this.new_operation_callback(operation)
	}

	async reset_selected()
	{
		if(! api.check_roles(this.self, [ "model" ]))
			return

		this.objects.forEach(obj => { obj.selected = false })

		this.bus.$emit("update_plots")
	}

	average(attr)
	{
		var average = 0
		var median = null
		var count = 0
		var objects = this.objects.filter(obj => ! obj.bad)

		if(attr.type == "number")
		{
			objects.forEach(
				obj =>
				{
					const value = obj[attr.key]

					if(value != null)
					{
						average += value
						count += 1
					}
				})

			if(count)
				average /= count
		}
		else
		{
			var values = {}

			objects.forEach(
				obj =>
				{
					const value = obj[attr.key]

					if(value != null)
					{
						if(values[value] == null)
							values[value] = 0

						values[value] += 1
						count ++
					}
				})

			var max_count

			Object.entries(values).forEach(
				desc =>
				{
					if(max_count == null || max_count < desc[1])
					{
						median = desc[0]
						max_count = desc[1]
					}
				})

			if(count)
				average = max_count / count
		}

		return { average : average, median : median }
	}

	async correlation(x_attr, y_attr = null)
	{
		if(y_attr == null)
			y_attr = this.uprs_attr

		if(x_attr == null)
			return

		const response = await api.call_without_component(this.self, "cadastral_groups", "get_analogues_comparative_correlation", { id : this.group_id, attr_1 : x_attr.id, attr_2 : y_attr.id })

		return api.round3(response.correlation)
	}

	add_axis_two_attrs(plot_data, container, key, attr, its_size, continuous_range, contrary_size, with_transform, axis_func)
	{
		const data = plot_data.map(elem => elem[key])
		var scale

		if(attr.type == "number")
		{
			attr.min = Math.min(...data)
			attr.max = Math.max(...data)
			attr.min_all = attr.min
			attr.max_all = attr.max
			attr.d = ( attr.max - attr.min ) / 10

			scale = d3.scaleLinear().domain([ attr.min - attr.d, attr.max + attr.d ]).range(continuous_range)
		}
		else
		{
			var uniq = new Set()

			if(attr.reference == null)
				data.forEach(value => uniq.add(value ? "Да" : "Нет"))
			else
				data.forEach(value => uniq.add(api.format_reference(attr.reference, value, true)))

			var uniq_sorted

			if(attrs_histogram[attr.id])
			{
				uniq_sorted = new Set(attrs_histogram[attr.id])

				uniq.forEach(elem => uniq_sorted.add(elem))
			}
			else
				uniq_sorted = uniq

			var range = [ 0 ]
			var step = its_size / ( uniq_sorted.size + 1 )
			var next = step

			uniq_sorted.forEach(
				() =>
				{
					range.push(next)
					next += step
				})
			range.push(its_size) //3633 #45: пропадает граница

			uniq_sorted = Array.from(uniq_sorted)
			uniq_sorted.splice(0, 0, "")
			scale = d3.scaleOrdinal().domain(uniq_sorted).range(range)
			attr.min = uniq_sorted[0]
			attr.max = uniq_sorted[uniq_sorted.length - 1]
		}

		if(with_transform)
			container.attr("transform", "translate(0, " + contrary_size + ")")

		container
			.call(axis_func(scale).ticks(10).tickFormat(value => api.format_tick_label(attr, value)).tickSize(-contrary_size))
			.call(g => g.selectAll(".domain").remove())

		return scale
	}
	
	new_domain_for_axis_two_attrs(plot_data, scale, key, attr, is_all = false)
	{
		if(attr.type == "number")
		{
			if(is_all)
			{
				attr.min = attr.min_all
				attr.max = attr.max_all
			}
			else
			{
				const raw_data = is_all ? plot_data : plot_data.filter(elem => ! this.bad(elem.id))
				const data = raw_data.map(elem => elem[key])

				attr.min = Math.min(...data)
				attr.max = Math.max(...data)
			}

			attr.d = ( attr.max - attr.min ) / 10

			scale.domain([ attr.min - attr.d, attr.max + attr.d ])
		}
	}

	objects_by_selection(selection)
	{
		var objects = []

		selection.each(
			raw =>
			{
				var obj = this.objects.find(_obj => _obj.id == raw.id)

				objects.push(obj)
			})

		return objects
	}

	toggle(selection, meta_pressed, set_selected = false)
	{
		const state = ! meta_pressed
		var objects = this.objects_by_selection(selection)

		if(objects.length == 0)
			return

		if(set_selected)
		{
			objects.forEach(
				obj =>
				{
					obj.selected = state
				})

			this.bus.$emit("update_plots")
		}
		else if(state)
		{
			var bad_ids = []

			objects.forEach(
				obj =>
				{
					if(! obj.bad)
						bad_ids.push(obj.id)
				})

			this.set_state(bad_ids, true)
		}
		else
		{
			var good_ids = []

			objects.forEach(
				obj =>
				{
					if(obj.bad)
						good_ids.push(obj.id)
				})

			this.set_state(good_ids, false)
		}
	}

	update_teach_test()
	{
		this.plots.forEach(plot => plot.update_teach_test())
	}

	plot_two_attrs(x_attr, y_attr)
	{
		var plot = Plot.two_attrs(this, x_attr, y_attr, this.ce_attrs_references, "uprs", false)

		this.plots.push(plot)

		return plot.data
	}

	plot_diff(model, attr_key = "diff", sort_by = "y", coef = 0)
	{
		var plot = Plot.diff(this, model, attr_key, sort_by, coef)

		this.plots.push(plot)

		return plot.data
	}

	diffs(model)
	{
		const values = this.objects.map(obj => obj.diff[model])
		const min = Math.min(...values)
		const max = Math.max(...values)

		return { diffs : values, min : min, max : max }
	}

	uprss()
	{
		const values = this.objects.map(obj => obj.current_version.attrs.uprs)
		const min = Math.min(...values)
		const max = Math.max(...values)

		return { uprss : values, min : min, max : max }
	}

	predicted_uprss(model)
	{
		const values = this.objects.map(obj => obj.predicted_uprs[model])
		const min = Math.min(...values)
		const max = Math.max(...values)

		return { uprss : values, min : min, max : max }
	}

	add_axis_min_max(container, min, max, its_size, continuous_range, contrary_size, with_transform, axis_func, margin)
	{
		const d = ( max - min ) / 10
		var scale = d3.scaleLinear().domain([ min - d, max + d ]).range(continuous_range)

		if(with_transform)
			container.attr("transform", "translate(" + margin.left + ", " + contrary_size + ")")
		else
			container.attr("transform", "translate(" + margin.left + ", 0)")

		container
			.call(axis_func(scale).ticks(9).tickFormat(value => api.number_to_string_with_ranking(value)).tickSize(-contrary_size))
			.call(g => g.selectAll(".domain").remove())

		return { scale : scale, d : d }
	}

	new_domain_for_axis_min_max(scale, min, max, min_all, max_all, is_all = false)
	{
		if(is_all)
		{
			min = min_all
			max = max_all
		}
		
		const d = ( max - min ) / 10

		scale.domain([ min - d, max + d ])

		return { min : min, max : max, d : d }
	}

	object(id)
	{
		return this.objects.find(obj => obj.id == id)
	}

	bad(id)
	{
		return this.object(id).bad
	}

	selected(id)
	{
		return this.object(id).selected
	}

	color(id)
	{
		const obj = this.object(id)

		return obj.selected ? "var(--bft-neutral-300)" : ( obj.bad ? "var(--bft-natural-900)" : "var(--bft-blue-500)" )
	}
}

var _objects = null
var attrs_histogram = {}

function init(self, group_id, ce, new_operation_callback, message_callback)
{
	if(group_id == null || ce == null)
		return null

	_objects = new Objects(self, group_id, ce.attrs, ce.attrs_references, new_operation_callback, message_callback)

	return _objects.refresh_objects()
}

function objects()
{
	return _objects
}

export default
{
	init,
	objects,
	attrs_histogram,
}

